export default {
  haulers: 'Перевезення',
  setup: 'Налаштування',
  driverExperience: 'Досвід водія',
  users: 'Користувачі',
};
